import axios from "axios";
export async function getJobsInProgress() {
    const response = await axios.get("/api/workflow/support/jobsAndAssignmentsInProgress");
    return response.data;
}
export async function sendSupportTicket(ticket) {
    await axios.post('/api/workflow/support/ticket', ticket);
}
